import React from "react";
import { ActivityFormThankContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Buttons, Headers, Icons, Navigations } from "components";

class ActivityFormThankContainer extends React.Component {
  handleBack = () => {
    const { router } = this.props;
    this.props.router.navigate(
      `${ROUTE_PATH.ACTIVITY_FORM}/${router.params?.id}`,
    );
  };

  render() {
    const { t, router, i18n } = this.props;
    const locationSplit = router.location.pathname.split("/");
    const isNoMember = !locationSplit.some((e) => e === "system");
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Activities", { ns: "common" }),
        path: ROUTE_PATH.ACTIVITIES,
      },
    ];
    return (
      <ActivityFormThankContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="activity_form_thank_container">
          <Headers.PageHeader
            icons={<Icons.ActivityCircle />}
            title={"ACTIVITY : Online form"}
            subTitle={"กิจกรรม: แบบฟอร์มออนไลน์"}
          />
          <div className="thank_label">
            {i18n.language === "en"
              ? "Thank you for joining our event.\nWe will send a confirmation email to the address you provided in the form."
              : "ขอบคุณที่เข้าร่วมกิจกรรม\nเราจะส่งอีเมลยืนยันไปยังที่อยู่อีเมลที่ท่านได้ให้ไว้ในแบบฟอร์ม"}
          </div>
          {!isNoMember && (
            <Buttons.BgStandard
              label={t("Back", { ns: "common" })}
              onClick={this.handleBack}
            />
          )}
        </div>
      </ActivityFormThankContainerStyled>
    );
  }
}

// export default withRouter(ActivityFormThankContainer);
export default withTranslation(["common"])(
  withRouter(ActivityFormThankContainer),
);
